import type { ComponentProps } from 'react'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import NavBarListItem from 'components/NavKit/NavBarListItem'
import NavBarListItemIcon from 'components/NavKit/NavBarListItemIcon'
import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import noop from 'lib/function/noop'
import moment from 'moment'
import { useTrips } from 'tripPlanner/hooks/api/trip'
import useWishlistsAndChatReleaseState from 'wishlists/hooks/useWishlistsAndChatReleaseState'

type InheritedListItemProps = Pick<ComponentProps<typeof NavBarListItem>, 'onClick'>

function AccountMenuTripPlannerListItem(props: InheritedListItemProps) {
  const intl = useIntl()
  const { shouldUseWishlists } = useWishlistsAndChatReleaseState()
  const { data: trips } = useTrips({ onError: noop, onSuccess: noop, enabled: !shouldUseWishlists })
  const upcomingTrips = useMemo(
    () => trips?.filter((trip) => !trip.endDate || trip.endDate > moment()) || [],
    [trips],
  )

  if (shouldUseWishlists) {
    const wishlistsText = intl.formatMessage({
      id: 'xrDH7TOWPQWTX6sgu1rp',
      defaultMessage: 'Wishlist',
      description: 'Wishlist navigation button text in the account menu',
    })

    return (
      <NavBarListItem
        {...props}
        startIcon={<NavBarListItemIcon Icon={LineHeartIcon} colour="primary" />}
        title={wishlistsText}
        to="/wishlists"
      />
    )
  }

  const tripPlansText = intl.formatMessage({
    id: 'PlZDImO9d6ZLP7trPiLB',
    defaultMessage: 'Trip Plans',
    description: 'Trip Plans navigation button text in the trip planner feature',
  })

  const upcomingCopy = upcomingTrips.length > 0
    ? intl.formatMessage(
        {
          id: '10nd9GG9XaxAyysErVe9',
          defaultMessage: '{count, plural, one {# upcoming} other {# upcoming}}',
          description: 'Number of upcoming trips count in the trip planner feature',
        },
        { count: upcomingTrips.length },
      )
    : undefined

  return (
    <NavBarListItem
      {...props}
      startIcon={<NavBarListItemIcon Icon={LineHeartIcon} colour="primary" />}
      title={tripPlansText}
      endTitle={upcomingCopy}
      to="/trip-planner"
    />
  )
}

export default AccountMenuTripPlannerListItem
